import { UserPopover } from "@src/features/userPopover/ui/UserPopover";
import { useState } from "react";
import { Avatar } from "@mui/material";
import ErrorBoundary from "@src/shared/ui/ErrorBoundary/ErrorBoundary";
import { Button } from "@src/shared/components/Button/Button";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import { getUserFirstLastName } from "../lib/userNameUtils";
import { NavLink, useNavigate } from "react-router-dom";
import avatarImg from "@src/shared/assets/avatar_img.svg";
import { NotificationsBell } from "@src/features/notificationsBell";
import { getWsUrl } from "@src/shared/lib/getWsUrl";
import { useNotificationsSocket } from "@src/entities/notifications/model/ws/useNotificationsSocket";

import styles from "./styles.module.scss";

const CREATE_REQUEST_PATH = "/creating-search";
// const CHANGE_REQUEST_PATH = "/change-search-query";

//Пути для Результаты ранжирования и Справка

export const Header = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  // const location = useLocation();
  const { user } = useUserInfoMeStore();
  const currentUser = getUserFirstLastName(user);
  const wsUrl = user?.id ? getWsUrl(`/api1/v2/events/${user.id}/ws`) : null;
  useNotificationsSocket(wsUrl);

  const handleCreateRequestClick = () => {
    navigate(CREATE_REQUEST_PATH, {
      state: {
        startNewRequest: true,
        startNewRequestNonce: Date.now(),
      },
    });
  };

  const onAvatar = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClosePopover = () => setOpen(false);
  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <div className={styles.headerItemLinkWrap}>
            <NavLink to="/search-history" className={styles.headerItemLink}>
              {({ isActive }) => (
                <div
                  className={
                    isActive ? styles.headerItemActive : styles.headerItem
                  }
                >
                  Результаты подбора
                </div>
              )}
            </NavLink>
          </div>
          <div className={`${styles.headerItem} ${styles.headerItemLinkWrap}`}>
            Результаты ранжирования
          </div>
          <div className={styles.headerItemLinkWrap}>
            <NavLink to="/select-tariff" className={styles.headerItemLink}>
              {({ isActive }) => (
                <div
                  className={
                    isActive ? styles.headerItemActive : styles.headerItem
                  }
                >
                  Тарифы
                </div>
              )}
            </NavLink>
          </div>
          <div className={styles.headerItemLinkWrap}>
            <NavLink to="/helper-tool" className={styles.headerItemLink}>
              {({ isActive }) => (
                <div
                  className={
                    isActive ? styles.headerItemActive : styles.headerItem
                  }
                >
                  Справка
                </div>
              )}
            </NavLink>
          </div>
        </div>

        <div className={styles.headerUser}>
          <div className={styles.notificationsBell}>
            <NotificationsBell />
          </div>
          <div className={styles.addButton} onClick={handleCreateRequestClick}>
            <Button btnText="Создать запрос" withIcon />
          </div>
          <div className={styles.avatarWrap}>
            <div className={styles.avatar}>
              <Avatar
                onClick={onAvatar}
                sx={{ bgcolor: "rgba(255, 255, 255, 0.75)", cursor: "pointer" }}
              >
                <img src={avatarImg} />
              </Avatar>
            </div>
            <div className={styles.avatarName} role="button" onClick={onAvatar}>
              {currentUser}
            </div>
            <ErrorBoundary>
              <UserPopover
                anchorEl={anchorEl}
                open={open}
                onClose={handleClosePopover}
              />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};
